import { useEffect, useState } from "react"
import { getCurrentBodyweightKg } from "@/lib/supabase"

/**
 * Poids de corps actuel à AFFICHER (tuile Poids, IMC, masse maigre, rapport 1RM /
 * poids de corps, fiche admin) : dernière pesée de `weight_history`, repli sur le
 * poids d'inscription — même règle que le calcul des charges (getCurrentBodyweightKg).
 *
 * `profile.weight` (useProfile) n'est PAS le poids actuel : c'est `wizard_submissions.weight`,
 * saisi à l'inscription et jamais mis à jour par une pesée.
 *
 * Lu à chaque montage : un écran rouvert après une pesée affiche la nouvelle valeur.
 * `bodyweightKg` vaut null pendant la lecture, et si l'utilisateur n'a ni pesée ni poids
 * d'inscription.
 */
export function useCurrentBodyweight(userId: string | null | undefined): {
  bodyweightKg: number | null
  loading: boolean
} {
  const [bodyweightKg, setBodyweightKg] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!userId) {
      setLoading(false)
      return
    }
    let mounted = true
    setLoading(true)
    getCurrentBodyweightKg(userId)
      .then((kg) => { if (mounted) setBodyweightKg(kg != null && kg > 0 ? kg : null) })
      .catch((err) => console.error("[useCurrentBodyweight]", err))
      .finally(() => { if (mounted) setLoading(false) })
    return () => { mounted = false }
  }, [userId])

  return { bodyweightKg, loading }
}
